<template>
  <div>
    <ul class="sa-card-list">
      <li v-for="(n, i) in apList" :key="i">
        <span class="sa-date sa-h-sm-up">{{ n.date }}</span>
        <template v-if="!n.okadoc">
          <div class="sa-card-list-box" @click="docDet(n.apnt_id)">
            <figure class="sa-avt-img">
              <img
                v-if="n.img"
                :src="n.img"
                alt="Doctor"
                class="sa-img-cover"
              />
              <img v-else :src="unknownImg" alt="Doctor" class="sa-img-cover" />
            </figure>
            <div class="sa-doct-det">
              <h6>{{ n.pname }}</h6>
              {{ n.st_nm }}
            </div>
            <div class="sa-doct-apoint">
              Appointment ID : {{ n.apnt_id }}
              <span class="sa-doct-apoint-time sa-h-xs">
                {{ n.time }}
                <dfn>{{ n.strt_tym }}</dfn>
              </span>
            </div>
          </div>
          <div class="sa-ins-apt">
            <span v-if="n && n.refil" class="sa-refill">Refill</span>
            <span class="sa-bupa-str" v-if="n && n.sales_channel == 'bupa'"
              ><i class="icon-Insurance2"></i> Bupa Appointment</span
            >
            <span class="sa-bupa-str" v-else-if="n && n.sales_channel == 'bupa_refill'"
              ><i class="icon-Insurance2"></i> Bupa Appointment</span
            >
          </div>
        </template>
        <div v-else-if="n.okadoc" class="sa-card-list-box">
          <figure class="sa-avt-img">
            <img v-if="n.img" :src="n.img" alt="Doctor" class="sa-img-cover" />
            <img v-else :src="unknownImg" alt="Doctor" class="sa-img-cover" />
          </figure>
          <div class="sa-doct-det">
            <h6>{{ n.pname }}</h6>
            {{ n.st_nm }}
          </div>
          <div class="sa-doct-apoint">
            Appointment ID : {{ n.apnt_id }}
            <span class="sa-doct-apoint-time sa-h-xs">
              {{ n.time }}
              <dfn>{{ n.strt_tym }}</dfn>
            </span>
          </div>
        </div>
        <div v-if="!n.okadoc" class="sa-card-list-box2">
          <!-- Ph : +{{n.pc}} {{n.ph}} -->
          <button
            v-if="n.stid == 'ST1'"
            :disabled="!n.enableChat"
            class="sa-btn sa-btn-primary"
            @click="chatPanel(n)"
          >
            Start chat
            <i class="icon-chat2"></i>
          </button>
        </div>
        <div v-else-if="n.okadoc" class="sa-card-list-box2">
          <!-- Ph : +{{n.pc}} {{n.ph}} -->
          <button
            v-if="n.stid == 'ST1'"
            :disabled="!n.enableChat"
            class="sa-btn sa-btn-primary"
            @click="okadoc(n)"
          >
            {{ n.booking_source.btnText }}
            <i class="icon-chat2"></i>
          </button>
        </div>
        <span class="sa-reschedule-apt" :class="[n.resch.status === 1?'sa-green-label':'sa-red-label']" v-if="n && n.resch && n.resch.label">{{n.resch.label}}</span>
      </li>
    </ul>
    <ul class="sa-pagination" v-if="totalpages > 1">
      <li class="sa-p-item">
        <a class="sa-p-link" v-if="currentPage != 1" @click="currentPage--">
          <i class="icon-left-arrow"></i>
        </a>
      </li>
      <li
        class="sa-p-item"
        v-for="i in pages.slice(currentPage - 1, currentPage + 5)"
        :key="i"
        :class="{ active: i == currentPage }"
      >
        <a class="sa-p-link" @click="currentPage = i"> {{ i }} </a>
      </li>
      <li class="sa-p-item">
        <a
          @click="currentPage++"
          v-if="currentPage < pages.length"
          class="sa-p-link"
        >
          <i class="icon-right-arrow"></i>
        </a>
      </li>
    </ul>
  </div>
</template>
<script>
import { pro_url, oh_url } from "../../../config/endpoints";
import moment from "moment";
import moment_time_zone from "moment-timezone";
export default {
  props: ["apList", "totalpages", "currentPage"],

  components: {},
  data() {
    return {
      activeClass: true,
      inactiveClass: "sa-gray-text",
      cTime: "",
      chatTime: null,
      size: 5,
      pageRange: 5,
      pages: [],
      unknownImg: "https://img.litedev.com/images/unknown-avtar.png",
    };
  },
  watch: {
    totalpages: {
      immediate: true,
      deep: true,
      handler() {
        this.pages = [];
        for (let index = 1; index <= this.totalpages; index++) {
          this.pages.push(index);
        }
      },
    },
    currentPage: {
      immediate: false,
      deep: true,
      handler() {
        this.$parent.getList(this.currentPage);
      },
    },
  },
  methods: {
    getChatextraTime() {
      let _self = this;
      _self.$store
        .dispatch("httpPost", {
          uri: `${oh_url}/general/getStaticData`,
          body: { mtype: [] },
        })
        .then((response) => {
          if ((response.status = 1000)) {
            _self.chatTime = Math.floor(response.data.chat_extratime / 3600);
          }
        })
        .catch((e) => {});
    },
    userMedia: function (callback) {
      if (typeof navigator != "undefined" && navigator.webkitGetUserMedia) {
        navigator.webkitGetUserMedia(
          { video: true, audio: true },
          function success() {
            // alert("audio video permissions granted");
            return callback(true);
          },
          function error() {
            // alert("audio video permission error");
            return callback(false);
          }
        );
      } else {
        alert("does not support webRTC");
        return callback(false);
      }
      if (typeof navigator != "undefined" && navigator.getUserMedia) {
        navigator.mediaDevices.getUserMedia(
          { video: true, audio: true },
          function success() {
            // alert("audio video permissions granted");
            return callback(true);
          },
          function error() {
            // alert("audio video permission error");
            return callback(false);
          }
        );
      } else {
        return callback(false);
      }
    },
    selectHandler() {},
    computedValue: function (t) {
      let time = moment(t, "hh:mmA");
      let endTime = moment(this.cTime, "hh:mmA");
      let val = time.isBefore(endTime);
      return val;
    },
    docDet(aid) {
      let _self = this;
      _self.$router.push({ path: "/appointments/doctor-details/" + aid });
    },
    chatPanel(appDetails) {
      this.$localStorage.set("appDetails", JSON.stringify(appDetails));
      this.$router.push({ path: "/appointments/chat-with-a-doctor" });
    },
    okadoc(n) {
      if (
        n &&
        n.booking_source &&
        n.booking_source.video &&
        !n.booking_source.video.enabled
      ) {
        this.$store.dispatch("SET_ALERTMESSAGE", {
          msg: n.booking_source.video.message,
          class: "sa-a-danger",
        });
        // window.open(n.booking_source.video.url)
      } else {
        this.userMedia(function (flag) {
          if (flag === true) {
            window.open(n.booking_source.video.url);
          } else {
            alert("please provide camera and microphone permission");
          }
        });
      }
    },
  },
  mounted: function () {
    this.getChatextraTime();
    var _self = this;
    setInterval(function () {
      if (_self.apList && _self.apList.length) {
        _self.apList.map((apt) => {
          let presentTime = moment().tz("Asia/Riyadh").format();
          let appStartTime = moment(
            apt.date + apt.strt_tym,
            "YYYY-MM-DDThh:mm A"
          )
            .tz("Asia/Riyadh", true)
            .format();
          let appEndTime = moment(apt.date + apt.end_tym, "YYYY-MM-DDThh:mm A")
            .tz("Asia/Riyadh", true)
            .format();
          let endTime = moment(appStartTime)
            .add(moment.duration(_self.chatTime, "hours"))
            .tz("Asia/Riyadh")
            .format();
          if (
            moment(presentTime).isAfter(moment(appStartTime)) &&
            moment(presentTime).isSameOrBefore(moment(endTime))
          ) {
            _self.$set(apt, "enableChat", true);
          } else {
            _self.$set(apt, "enableChat", false);
          }
        });
      }
    }, 1000);
  },
};
</script>
<style>
.sa-reschedule-apt {
    font-size: 12px;
    padding: 5px;
    margin: 15px -20px -20px;
    text-align: center;
    border-radius: 0 0 7px 7px;
}
.sa-green-label{
  background-color: #EBFFE9;
  color: #3DB232;
}
.sa-red-label{
  color: #FF0000;
  background-color: #FFE9E9;
}
</style>
